import React from "react";
import {
    Checkbox,
    FormControl,
    ListItemText,
    MenuItem,
    Select
} from "@mui/material";

interface MultiSelectDropdownProps {
    options: number[];
    selectedValues: number[];
    onChange: (values: number[]) => void;
    getLabel: (value: number) => string;
    placeholder: string;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
    options,
    selectedValues,
    onChange,
    getLabel,
    placeholder
}) => {
    const handleChange = (event: any) => {
        const {
            target: { value }
        } = event;
        const selected =
            typeof value === "string" ? value.split(",").map(Number) : value;
        onChange(selected);
    };
    return (
        <div className="dropdown input-dropdown">
            <FormControl fullWidth>
                <Select
                    multiple
                    value={selectedValues}
                    onChange={handleChange}
                    displayEmpty
                    renderValue={(selected) =>
                        selected.length
                            ? selected.map((id) => getLabel(id)).join(", ")
                            : placeholder
                    }
                >
                    {options.map((option) => (
                        <MenuItem key={option} value={option}>
                            <Checkbox
                                checked={selectedValues.includes(option)}
                            />
                            <ListItemText primary={getLabel(option)} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};

export default MultiSelectDropdown;
